var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnterpriseColored(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2633",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconEnterpriseColored_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2444",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2632",
    clipPath: "url(#iconEnterpriseColored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20542",
    d: "M40 0A40 40 0 110 40 40 40 0 0140 0",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20543",
    d: "M63.599 36.14a.947.947 0 000-.419.992.992 0 00-.16-.439l-7.14-10.453a.983.983 0 000-.239 1 1 0 00-1.018-.539H24.94a.975.975 0 00-.4.12.912.912 0 00-.16.16.885.885 0 00-.16.139l-7.64 10.693a1 1 0 00-.179.5.985.985 0 000 .459.85.85 0 000 .139l23.7 26.654h1.138L63.184 36.4a.86.86 0 000-.12 3.463 3.463 0 00.419-.14m-23.561-9.356l5.626 7.98H34.356l3.431-4.868zm6.384 9.975L40.74 58.704l-6.883-21.945zm-7.98 21.347L19.613 36.739h12.15zm9.975-21.347h12.09L42.935 58.146zm1.157-2l5.566-7.98 5.566 7.98zm3.651-8.718l-5.566 7.98-5.564-7.975zm-18.53 4.873l-2.2 3.112-4.748-6.743-.878-1.237h11.254zm-9.755-4.13l4.768 6.723.878 1.237H19.314z",
    fill: "#1d7cab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterpriseColored);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconEnterpriseColored.d600a4ef.svg";
export { MemoForwardRef as ReactComponent };